@use "@fukuri-admins/ui/layout" as *;

.container {
    &_Header {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .title {
        color: text('High');
        @include typography('Jp/20_W6');
    }
    .table {
        padding-top: spacing('20');
    }
}

.tableHeader {
  display: grid;
  grid-template-columns: 80px 80px 1fr 1fr 1fr 80px;
  background-color: #e8e8e8;
}

.tableHeaderCell {
  font-size: 14px;
  font-weight: 600;
  color: #797f7f;
  border-right: 1px solid #ffffff;
  transition: all 0.3s ease-out;
  padding: 12px 20px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: spacing('4');

  &:last-child {
    border-right: none;
  }
}

.infoIcon {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: text('Low');
}

.tableRow {
  display: grid;
  grid-template-columns: 80px 80px 1fr 1fr 1fr 80px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.2s ease-out;
  background: white;

  &:hover {
    background-color: $WhiteHover;
  }

  &:last-child {
    border-bottom: solid 1px transparent;
  }
}

.tableCell {
  padding: 12px 20px;
  display: flex;
  align-items: center;
  min-width: 0;
}

.tableCellText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dragHandle {
  display: flex;
  align-items: center;
  color: text('Low');
  cursor: grab;

  // svgIcon クラスが color: text('High') を持つため、詳細度を上げて上書きする
  svg {
    color: inherit;
  }

  &:active {
    cursor: grabbing;
  }
}

.iconButton {
  padding: 4px;
}

.menuItemDelete {
  color: text('Red') !important;
}
